import "./App.css";
import { Routes, Route, Outlet } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Footer from "./layouts/Footer";
import Navbar from "./layouts/Navbar";
import HomePage from "./screens/HomePage";
import ServicePage from "./screens/ServicePage/ServicePage";
import MdWriterScreen from "./mdwriter/MdWriterScreen";
import AdminLogin from "./screens/Admin/AdminLogin";
import AdminLayout from "./screens/Admin/AdminLayout";
import AdminOverview from "./screens/Admin/AdminOverview";
import AdminRequestsPage from "./screens/Admin/AdminRequestsPage";
import AdminRequestEditPage from "./screens/Admin/AdminRequestEditPage";
import AdminContactPage from "./screens/Admin/AdminContactPage";
import AdminContactEditPage from "./screens/Admin/AdminContactEditPage";
import AdminEmailAnalysisPage from "./screens/Admin/AdminEmailAnalysisPage";
import AdminEmailAnalysisDetailPage from "./screens/Admin/AdminEmailAnalysisDetailPage";
import PrivacyPolicy from "./screens/Legal/PrivacyPolicy";
import TermsOfUse from "./screens/Legal/TermsOfUse";
import NotFoundPage from "./screens/NotFound/NotFoundPage";
import AdminNotFound from "./screens/Admin/AdminNotFound";

function SiteLayout() {
  return (
    <>
      <Navbar />
      <div className="header--new__mask" />
      <main id="main-content" className="page-main" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminLayout />}>
          <Route index element={<AdminOverview />} />
          <Route path="requests" element={<AdminRequestsPage />} />
          <Route path="requests/:id" element={<AdminRequestEditPage />} />
          <Route path="email-analysis" element={<AdminEmailAnalysisPage />} />
          <Route path="email-analysis/:id" element={<AdminEmailAnalysisDetailPage />} />
          <Route path="contact" element={<AdminContactPage />} />
          <Route path="contact/:id" element={<AdminContactEditPage />} />
          <Route path="*" element={<AdminNotFound />} />
        </Route>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/mdwriter" element={<MdWriterScreen />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/service/:serviceName" element={<ServicePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
